export default __webpack_public_path__ + "static/media/image-thank-you-celcom.0a86638c.svg";